<template>
    <QzDialog
      width="861px"
      :visible.sync="show"
      :noConfirm="true"
      :cancelText="$t('common.iGotIt2')"
      cancelType="normal"
    >
    <img :src="`https://crs-1258682338.cos.ap-beijing.myqcloud.com/all-front-js/globalTipNew.png?tag=${Math.random()}`" class="global-tip-img" alt="">
    </QzDialog>
</template>
<script>
export default {
    name: "GlobalTip",
    computed: {
        show: {
            get() {
                const nowTime = window.formateTimesStamp()
                if (nowTime >= '2020-09-14 00:00:00' && nowTime <= '2020-11-06 06:00:00')
                return this.$store.getters.showGlobalTip
            },
            set(value) {
                if (!value)  {
                    this.$store.commit('user/SET_GLOBAL_TIP', false)
                }
            }
        }
    }
}
</script>
<style scoped>
    .global-tip-img {
        width: 100%;
    }
</style>